import { registerConsentEffect } from "../../cookie-consent-registry";

registerConsentEffect("desempenho", {
  onGrant: () => {
    window.gtag?.("consent", "update", {
      analytics_storage: "granted",
    });

    window?.dataLayer?.push({
      event: "consent_update",
    });
  },

  onDeny: () => {
    window.gtag?.("consent", "update", {
      analytics_storage: "denied",
    });
    
    window?.dataLayer?.push({
      event: "consent_update",
    });
  },
});
